import {
  EMPTY_LIST,
  EMPTY_OBJECT,
  EMPTY_STRING,
} from '../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../constants/html'
import { PROFILE_ROUTE_NAMES } from '../../../../constants/route'
import {
  getIsListingPublicationLive,
  getListingPortalLabel,
  getListingUnitLabel,
} from '../../../RentalPortalListing'
import { LISTING_PROFILE_TAB_APPLICANTS } from '../../RentalPortal.constants'
import { RentalPortalBlockDisabledEditButton } from '../../RentalPortalBlockDisabledEditButton'

import {
  LISTING_PUBLISHINGS_TAB_SEGMENT,
  QA_NAME_LISTING_PROFILE_PREVIEW_OPEN_FULL_PAGE,
} from './RentalPortalListingProfile.constants'

export function getListingProfileTitle({ listingData, t }) {
  return (
    listingData?.display_name ||
    getListingUnitLabel({ listing: listingData, t })
  )
}

export function toListingProfileUserValue(user) {
  return user
    ? {
        archived: user.is_archived,
        avatarColor: user.avatar_color,
        email: user.email,
        fullname: user.full_name,
        id: user.id,
      }
    : null
}

export function getListingProfilePreviewOpenFullPageProps({
  Actions,
  listingId,
  t,
  tab,
  onClosePreview,
}) {
  function getProfileLink({ id }) {
    return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
      additionalParams: tab ? `/${tab}` : EMPTY_STRING,
      id,
    })
  }

  return {
    Actions,
    getProfileLink,
    id: listingId,
    openInNewTabButtonProps: {
      qaName: QA_NAME_LISTING_PROFILE_PREVIEW_OPEN_FULL_PAGE,
      tooltip: t('RentalPortal.ListingProfilePreviewOpenFullPageBtnKey'),
    },
    openLinkTarget: HTML_LINK_TARGET.self,
    onClosePreview,
  }
}

export function getListingApplicantsTabUrl(listingId) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    additionalParams: `/${LISTING_PROFILE_TAB_APPLICANTS}`,
    id: listingId,
  })
}

export function getListingPublishingsTabUrl(listingId) {
  return PROFILE_ROUTE_NAMES.rentalPortalListingProfile({
    additionalParams: `/${LISTING_PUBLISHINGS_TAB_SEGMENT}`,
    id: listingId,
  })
}

export function getListingProfileLivePortalNames(listingData) {
  return (listingData.portal_publications ?? EMPTY_LIST)
    .filter(getIsListingPublicationLive)
    .map(publication => getListingPortalLabel(publication.portal))
}

export function getListingProfileWidgetActionsProps({
  isPreview,
  listingData,
}) {
  if (isPreview) {
    return { EditButton: null }
  }

  return listingData?.permissions?.can_edit
    ? EMPTY_OBJECT
    : { EditButton: RentalPortalBlockDisabledEditButton }
}
